import type { IDelta, TStatBoxV2Change } from '@feathr/components';

export type { IDelta } from '@feathr/components';
export { calcDelta } from '@feathr/components';

type TDeltaStatBoxProps = {
  change?: TStatBoxV2Change;
  changeValue?: string;
  description?: string;
};

/**
 * Maps an IDelta to StatBoxV2 change/changeValue/description props.
 *
 * @param delta - The delta to map.
 * @param comparedLabel - The description label shown when a change is present.
 * @returns StatBoxV2 props for the change indicator, or an empty object when direction is 'none'.
 */
export function deltaProps(delta: IDelta, comparedLabel: string): TDeltaStatBoxProps {
  if (delta.direction === 'none') {
    return {};
  }
  return {
    change: delta.direction,
    changeValue: `${delta.pct.toFixed(1)}%`,
    description: comparedLabel,
  };
}
